import { toast } from "react-toastify";

const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const handleApiError = (err, history) => {
  if (!err || !err.message) return;

 

  console.log("errror",err)
  if (err.message.includes("403")) {
    localStorage.clear();
    toast.error('Your login session has been expires', toastOptions);
    setTimeout(()=>{
        history.push("/");
    },[1500])
  }else{
    toast.error(err.message, toastOptions);
  }
};
